import React from 'react';

export const CustomTooltip = ({ active, payload, label, valueFormatter }) => {
  if (!active || !payload || !payload.length) return null;
  const fmt = valueFormatter || ((v) => v);
  return (
    <div className="bg-white/90 dark:bg-slate-900/90 backdrop-blur-md border border-slate-200 dark:border-slate-800 p-3 rounded-lg shadow-xl text-sm min-w-[150px]">
      {label != null && label !== '' && (
        <p className="font-semibold text-slate-700 dark:text-slate-200 mb-1.5">{label}</p>
      )}
      <div className="space-y-1">
        {payload.map((e, i) => (
          <div key={i} className="flex items-center justify-between gap-4">
            <span className="flex items-center gap-1.5 text-slate-500 dark:text-slate-400">
              <span className="w-2 h-2 rounded-full" style={{ background: e.color || e.stroke || e.fill }} />
              {e.name}
            </span>
            <span className="font-semibold text-slate-800 dark:text-slate-100">{fmt(e.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
